export const configurator = {
    // has to be in "/images/" folder
    "background": "products/rust_server.jpg",
    "inputs": {
        "cpu": {
            "type": "select",
            "options": {
                "200": 3.00,
                "300": 4.50,
                "400": 6.00,
            },
            "defaultoption": "200",
            "showonsummary": true
        },
        "ram": {
            "type": "select",
            "options": {
                "6": 9.00,
                "8": 12.00,
                "10": 15.00,
                "12": 18.00,
                "14": 21.00,
                "16": 24.00,
                "18": 27.00,
                "20": 30.00,
            },
            "defaultoption": "10",
            "showonsummary": true
        },
        "storage": {
            "type": "select",
            "options": {
                "50": 2.00,
                "75": 3.00,
                "100": 4.00,
                "200": 8.00,
            },
            "defaultoption": "50",
            "showonsummary": true
        }
    },
    "duration": {
        "daysForInterval": 30,
        "type": "select",
        "options": {
            "10": 1.1,
            "30": 1,
            "60": 1,
            "90": 0.9
        },
        "defaultoption": "30",
    }
}
